import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Link } from 'foundations-components/transitional/components/Link';
import { Children } from 'react';

// import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { CardHeader, CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ExpandingFAQ = ({
  Title,
  Content,
  onExpandedChange
}) => /*#__PURE__*/_jsxs(CardWrapper, {
  compact: true,
  defaultExpanded: false,
  expandable: true,
  borderWidth: "100",
  borderStyle: "solid",
  borderColor: "border-core-default",
  borderRadius: "300",
  onExpandedChange: onExpandedChange,
  children: [/*#__PURE__*/_jsx(CardHeader, {
    title: Title,
    titleSize: "small"
  }), /*#__PURE__*/_jsx(CardSection, {
    children: Content
  })]
});
export const FrequentlyAskedQuestionsContainer = ({
  children,
  columns = 2,
  handleProductAndServicesCatalogClick
}) => {
  const childrenArray = Children.toArray(children);
  const faqGrid = columns === 1 ? /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    inlineSize: "100%",
    children: childrenArray
  }) : /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    gap: "400",
    flexWrap: "wrap",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(Flex, {
      flexBasis: "100%",
      flex: "1",
      flexDirection: "column",
      children: childrenArray.filter((_, index) => index % 2 === 0)
    }), /*#__PURE__*/_jsx(Flex, {
      flexBasis: "100%",
      flex: "1",
      flexDirection: "column",
      children: childrenArray.filter((_, index) => index % 2 === 1)
    })]
  });
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "1400",
    children: [/*#__PURE__*/_jsx(H2, {
      marginBlockEnd: "500",
      "aria-level": 2,
      typography: "heading-400",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "faq.title"
      })
    }), faqGrid, /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(Text, {
        as: "small",
        paddingBlockStart: "400",
        paddingBlockEnd: "500",
        textAlign: "center",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "pricingPage.productServicesCatalogPrompt_jsx",
          elements: {
            UILink: Link
          },
          options: {
            onClick: handleProductAndServicesCatalogClick
          }
        })
      })
    })]
  });
};